export default __webpack_public_path__ + "f4ae97786342f2728044ed1129ef4d65.png";